import { toast, ToastOptions } from 'react-toastify'
import { ReactNode } from 'react'
import {
  bindStatusListenersToOptions,
  isToastInBuggedState,
  isToastOpen,
  waitUntilToastIsClosed
} from '../utils/openStatusTracker'

export type ToastId = string | number
type Params = { layout: ReactNode; options?: ToastOptions }

export const dispatchOrUpdateToast = ({ layout, options }: Params) => {
  const id = options?.toastId
  const optionWithStatusListeners = bindStatusListenersToOptions(options)

  if (isToastInBuggedState(id)) {
    redispatchToastOnceOldCloses(layout, options!)
    return
  }

  if (isToastOpen(id)) {
    toast.update(id, { ...optionWithStatusListeners, render: layout })
    return
  }

  toast(layout, optionWithStatusListeners)
}

const redispatchToastOnceOldCloses = (layout: ReactNode, options: ToastOptions) => {
  waitUntilToastIsClosed(options?.toastId!)
    .then(() => dispatchOrUpdateToast({ layout, options }))
    .catch()
}
